import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'
import extractApiData from 'Helpers/extractApiData'

const endpoints = ((baseURL) => {
  return {
    getSmsMessageGetSMSDetails: (idMessage) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}`,
    getAllSMSMessages: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/message/search?${encodeParams(params)}`,
    getEntitiesThatUseMessage: (idMessage) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/entities`,
    copyMessage: (idMessage, notes) =>
      `${baseURL}/api/message/${encodeURIComponent(
        idMessage
      )}/clone?Note=${encodeURIComponent(notes)}`,
    getSmsMessageMinimumDetails: (idMessage) =>
      `${baseURL}/api/message/${idMessage}`,
    getMessages: (idList, params) =>
      `${baseURL}/api/list/${idList}/message/search?${encodeParams(params)}`
  }
})(process.env.BESMSMESSAGE_URL)

export const beSmsMessageGetSMSDetails = (idMessage) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getSmsMessageGetSMSDetails(idMessage),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}

export const beSmsMessageGetAllMessages = (idList, params, data) => {
  const url = endpoints.getAllSMSMessages(idList, params)
  return apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beSmsMessageGetMessages = (idList, params, data) => {
  const url = endpoints.getMessages(idList, params)
  return apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beSmsMessageCopyMessage = (
  idMessage,
  notes,
  Reason,
  ReasonDetails
) => {
  const url = endpoints.copyMessage(idMessage, notes)

  return apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      Reason,
      ReasonDetails
    }
  }).then(extractApiData)
}

export const beSmsMessageGetEntitiesThatUseMessage = (idMessage) => {
  const url = endpoints.getEntitiesThatUseMessage(idMessage)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

export const beSmsMessGetMessageMinimumDetails = (idMessage) => {
  const url = endpoints.getSmsMessageMinimumDetails(idMessage)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}
